import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  Field,
  CurrencyField,
  DateTimeField,
  PaymentsDataField,
  BilledField,
  PaidBadge,
} from '../../../commons/DataTable';
import IAFCustomCheckboxes from '../../../commons/Checkboxes/IAFCustomCheckboxes';
import { useAuth } from '../../../commons/Auth';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';
import CustomerNameFieldRendicontazioni from '../../../commons/DataTable/CustomerNameFieldRendicontazioni';
import AdminField from '../../../commons/DataTable/AdminField';

function RoyaltyTable({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  showEmptyTableMessage,
  truncateTable,
  onSelectChange,
  allowedRoles = [],
  subAdmins = false,
  profileType,
  profile,
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin }] = useAuth();
  const { offset, limit } = query;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable && (
        <IAFCustomCheckboxes
          onSelectChange={onCheck}
          onClick={(e) => e.stopPropagation()}
          visible={newIsAdmin && profile.type !== 'UTILIZER'}
        />
      )}
      {!truncateTable && (
        <Field
          title="Nome Fornitore"
          source="supplier.businessName"
          className="text-left"
        />
      )}
      {!truncateTable && <Field title="Numero Fattura" source="number" />}
      {!truncateTable && (
        <DateTimeField title="Data Fattura" source="date" format="DD/MM/YYYY" />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Mese Rend."
          source="accountability"
          format="MM/YYYY"
        />
      )}
      {!truncateTable && (
        <Field title="Responsabile cliente" source="admin.businessName" />
      )}
      <CustomerNameFieldRendicontazioni
        title="Cliente"
        source="customerInfo"
        visible={!truncateTable}
      />
      <Field
        title="Referente ufficio"
        source="customerInfo.office.contactPerson"
        visible={!truncateTable && profileType === 'ASSOCIATION'}
      />
      <Field
        title="Ragione sociale ufficio"
        source="customerInfo.office.businessName"
        visible={!truncateTable && profileType === 'ASSOCIATION'}
      />
      <Field
        title="Ufficio"
        source="customerInfo.office.office"
        visible={!truncateTable && profileType === 'ASSOCIATION'}
      />
      <CurrencyField
        title="Imponibile"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="Importo da Incassare"
        source="gross"
        className="txt-table-right"
      />
      <PaymentsDataField title="Importo Incassato" source="payments" type="total" />
      <PaidBadge title="Pagato" source="paid" visible={!truncateTable}/>
      <CurrencyField
        title="Profitto Extra"
        source="extraShare"
        class="txt-table-right"
        visible={newIsAdmin}
      />
      <CurrencyField
        title={`Quota responsabile (${
          subAdmins
            ? '1'
            : profile?.type === 'AGENCY'
            ? '7'
            : profile?.type === 'COMMERCIAL'
            ? '7'
            : '10'
        }%)`}
        source="adminShare"
        className="txt-table-right"
        visible={!['UTILIZER', 'ASSOCIATION'].includes(profile.type)}
      />
      <CurrencyField
        title={`Quota responsabile`}
        source="adminShare"
        className="txt-table-right"
        visible={['ASSOCIATION'].includes(profile.type)}
      />
      <CurrencyField
        title="Quota responsabile maturata"
        source="earnedAdminShare"
        className="txt-table-right"
        visible={profile.type !== 'UTILIZER'}
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableAdminShare"
        className="txt-table-right"
        visible={profile.type !== 'UTILIZER'}
      />
      <BilledField
        title="Invitato a Fatturare"
        className="txt-table-right"
        subAdmins={subAdmins}
        visible={!truncateTable && newIsAdmin && profile.type !== 'UTILIZER'}
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iafs.0.number"
        visible={!truncateTable && newIsAdmin && profile.type !== 'UTILIZER'}
      />
    </DataTable>
  );
}

export default withRouter(RoyaltyTable);
